import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/data/site";

export default function FloatingActions() {
  return (
    <div className="fixed right-3 sm:right-4 bottom-4 sm:bottom-6 z-40 flex flex-col gap-2.5 sm:gap-3" style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }} data-testid="floating-actions">
      <a
        href={`https://wa.me/${SITE.jabalpur.whatsapp}?text=Hi%2C%20I%20want%20to%20enquire%20about%20home%20tuition%20by%20Unique%20Home%20Tutors.`}
        target="_blank" rel="noreferrer"
        className="w-12 h-12 sm:w-14 sm:h-14 rounded-full grid place-items-center text-white shadow-xl"
        style={{ background: "#25D366" }}
        aria-label="WhatsApp" data-testid="float-whatsapp"
      >
        <MessageCircle size={20} />
      </a>
      <a
        href={`tel:${SITE.jabalpur.phoneRaw}`}
        className="w-12 h-12 sm:w-14 sm:h-14 rounded-full grid place-items-center text-brand-deep bg-brand-cyan shadow-xl"
        aria-label="Call" data-testid="float-call"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
